// extracted by mini-css-extract-plugin
export default {"Checkbox_basic":"Checkbox_Checkbox_basic__Gzc7g","NotValid":"Checkbox_NotValid__YwUtF","Checkbox_external":"Checkbox_Checkbox_external__zkCPf"};